module.exports = __webpack_public_path__ + "img/img02.e523d16d.png";